import ApplyToAllDataRoomsModal from './ApplyToAllDataRoomsModal.component';

export default ApplyToAllDataRoomsModal;
